module.exports = __webpack_public_path__ + "media/images/application/template/logos/miele-1a69e9e96ecdc8ed1919fa2a44594685.png";